export default __webpack_public_path__ + "static/media/ods.9e984f07.svg";